import React from "react";
import { connect } from "react-redux";
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { SetDepositMoneyStatus } from '$Deposits/store/actions/DepositAction'


class MoneyInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        const {
            MethodsDetails,
            MethodsActive,
            SetDepositMoneyStatus,
            DepositMoneyStatus,
            MethodCodeActive,
            MoneyInput,
        } = this.props;
        const { code } = MethodsActive || {}
        const { maxBal, minBal } = MethodsDetails && MethodsDetails.setting || {}
        const { money, moneyErrMsg } = DepositMoneyStatus || {}

        return (
            <>
                {
                    MethodCodeActive != 'CHANNEL' &&
                    <>
                        <MoneyInput
                            type={'number'}
                            title={'ยอดฝาก'}
                            stateVal={moneyErrMsg}
                            value={money}
                            placeholder={`ฝากเงินขั้นต่ำ ${numberWithCommas(minBal)} บาท สูงสุด ${numberWithCommas(maxBal)} บาท ต่อรายการ`}
                            onChange={(value) => { SetDepositMoneyStatus(value, MethodsDetails) }}
                        />
                    </>
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    MethodsDetails: state.MethodsDetails,
    DepositMoneyStatus: state.DepositMoneyStatus,
    MethodCodeActive: state.MethodCodeActive,
});
const mapDispatchToProps = {
    SetDepositMoneyStatus: (money, methodsDetails) => SetDepositMoneyStatus(money, methodsDetails),
};
export default connect(mapStateToProps, mapDispatchToProps)(MoneyInput);


